import React from 'react';
import PropTypes from 'prop-types';
import Toggle from 'components/toggle';

import { Col, Row, Checkbox, Radio, ControlLabel, FormGroup } from 'react-bootstrap';
import { includes, map } from 'lodash';

export default class FilterCheckboxGroup extends React.Component {
  static propTypes = {
    behaviorToggle: PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.string,
      checked: PropTypes.bool,
      onChange: PropTypes.func
    }),
    checkAllIfNone: PropTypes.bool,
    children: PropTypes.node,
    defaultKey: PropTypes.string,
    inline: PropTypes.bool,
    label: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
      className: PropTypes.any,
      id: PropTypes.any,
      value: PropTypes.any,
      label: PropTypes.any
    })).isRequired,
    selected: PropTypes.any,
    singleSelection: PropTypes.bool,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    defaultKey: ''
  }

  checkAll = () => {
    const { selected, checkAllIfNone } = this.props;
    return checkAllIfNone && Array.isArray(selected) && selected.length === 0;
  }

  handleChange = (e) => {
    if (!this.checkAll()) return this.props.onChange(e);

    e.target.checked = true;
    this.props.onChange(e);
  }

  render() {
    return (
      <FormGroup className="mb-0">
        {this.props.label && <ControlLabel>{this.props.label}</ControlLabel>}
        <Row>
          <Col className={this.props.inline ? 'inline-filter-checkbox-group' : 'filter-checkbox-group'} xs={12}>
            {this.renderBehaviorToggle()}
            {this.renderOptions()}
            {this.props.children}
          </Col>
        </Row>
      </FormGroup>
    );
  }

  isChecked(value) {
    if (this.props.singleSelection) {
      return this.props.selected === value;
    } else {
      return includes(this.props.selected || [], value);
    }
  }

  renderOptions() {
    const Control = this.props.singleSelection ? Radio : Checkbox;
    return map(this.props.options, (option, i) => (
      <div className="filter-checkbox" key={this.props.defaultKey ? this.props.defaultKey + option.id || i : i}>
        <Control
          aria-label={option.value}
          checked={this.checkAll() || this.isChecked(option.value)}
          className={option.className}
          inline={true}
          name={`${option.value}_check`}
          value={option.value}
          onChange={this.handleChange}
        >
          {option.label}
        </Control>
      </div>
    ));
  }

  renderBehaviorToggle() {
    if (!this.props.behaviorToggle) return null;

    const { label, onChange, checked } = this.props.behaviorToggle;
    return (
      <div className="filter-checkbox behavior-toggle">
        <Toggle
          checked={checked}
          theme="buildout"
          onChange={onChange}
        />
        <span>{label}</span>
      </div>
    );
  }
}
